import { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { Badge, Button } from '@mui/material';
import { useSelector } from 'react-redux';
import { isEmpty } from 'lodash';
import { usePrescriptionReviewSelection } from './PrescriptionReviewSelectionContext';
import BulkManageTagsDialog from './BulkManageTagsDialog';

const BulkTagPrescriptionButton = ({ onSuccess }) => {
  const { selectedItemIds } = usePrescriptionReviewSelection();
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [selectedLineItems, setSelectedLineItems] = useState([]);

  const { pages, currentPage } = useSelector(({ workQueue }) => workQueue.prescriptionReview);
  const prescriptions = useMemo(() => pages[currentPage] || [], [pages, currentPage]);

  useEffect(() => {
    if (!isEmpty(selectedItemIds) && !isEmpty(prescriptions)) {
      const selectedItems = prescriptions
        .filter((prescription) =>
          selectedItemIds.includes(prescription.lineItem?.requestLineItemId)
        )
        .map((prescription) => ({
          lineItemId: prescription.lineItem.requestLineItemId,
          orderId: prescription.orderId,
          mpi: prescription.patient.mpi,
          patientName: prescription.patient.patientName,
          medicationName: prescription.drugName || prescription.prescriptionData?.drug,
          quantity: prescription.quantity,
          tags: prescription.lineItem.tags || [],
        }));
      setSelectedLineItems(selectedItems);
    } else {
      setSelectedLineItems([]);
    }
  }, [selectedItemIds, prescriptions]);

  const handleOpenDialog = () => {
    setIsDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setIsDialogOpen(false);
  };

  const handleSuccess = () => {
    handleCloseDialog();
    if (onSuccess) {
      onSuccess();
    }
  };

  const itemCount = selectedItemIds.length;
  const isDisabled = itemCount === 0;

  return (
    <>
      <Badge color='error' badgeContent={itemCount} sx={{ mx: 1 }}>
        <Button
          variant='contained'
          color='primary'
          onClick={handleOpenDialog}
          disabled={isDisabled}
          sx={{ height: 33 }}
        >
          Tag Items
        </Button>
      </Badge>

      {isDialogOpen && (
        <BulkManageTagsDialog
          open={isDialogOpen}
          onClose={handleCloseDialog}
          selectedLineItems={selectedLineItems}
          onSuccess={handleSuccess}
        />
      )}
    </>
  );
};

BulkTagPrescriptionButton.propTypes = {
  onSuccess: PropTypes.func,
};

BulkTagPrescriptionButton.defaultProps = {
  onSuccess: undefined,
};

export default BulkTagPrescriptionButton;
